import { AppState } from 'Store'

export const orderBlacklistSelect = {
	getAll: (state: AppState) => state.orders.ordersBlackList.blackList.entries,
	getTotal: (state: AppState) => state.orders.ordersBlackList.blackList.total_entries,
	getParams: (state: AppState) => state.orders.ordersBlackList.requestParams,
}
